
export const latestMessageString = (message) => {

  let latestMsgStr = '';
  if (message.msg_type === 'Text') {
    latestMsgStr = message.msg_content.text;
  }else if (message.msg_type === 'Image') {
    latestMsgStr = '[图片]';
  }else if (message.msg_type === 'Audio') {
    latestMsgStr = '[语言]';
  }else if (message.msg_type === 'Unknown') {
    latestMsgStr = '[其他]'
  }
  return latestMsgStr;
};

export const deepClone = (initalObj) => {
  let obj = {};
  try {
    obj = JSON.parse(JSON.stringify(initalObj));
  }catch(err) {
    console.log(err);
  }
  return obj;
};

export const emojiList = [
  '😃','😍','😔','😳',
  '😘','😉','😠','😞',
  '😥','😭','😝','😡',
  '😣','😒','😄','😷',
  '😓','😂','😊','😢',
  '😜','😨','😰','😵',
  '😏','😱','😪','😖',
  '😌','😈','👻','🎅',
  '🐶','🐷','🐱','👍',
  '👎','👊','✊','✌',
  '💪','👏','👈','👆',
  '👉','👇','👌','❤',
  '💔','🌟','⚡','👄',
  '🌹','☕','🎂','🍺'
];



// WEBPACK FOOTER //
// ./src/common/im/util.js